export default {
  getList: {
    method: 'post',
    url: '/vehicle/remooc-category/list'
  },
  add: {
    method: 'post',
    url: '/vehicle/remooc-category'
  },
  delete: {
    method: 'delete',
    url: '/vehicle/remooc-category'
  },
  archive: {
    method: 'delete',
    url: '/vehicle/remooc-category/archive'
  },
  restore: {
    method: 'put',
    url: '/vehicle/remooc-category/restore'
  },
  edit: {
    method: 'put',
    url: '/vehicle/remooc-category/id'
  },
  find: {
    method: 'get',
    url: '/vehicle/remooc-category/find?key=KEY'
  },
  detail: {
    method: 'get',
    url: '/vehicle/remooc-category/detail/ID'
  }
}
